import { useProductManagerActions } from "@iso/actions/productManager.actions";
import { useStoreManagerActions } from "@iso/actions/storeManager.actions";
import {
   Form,
   Input,
   message,
   Popconfirm,
   Radio,
   Select,
   Spin,
   Collapse,
   Divider,
} from "antd";
import { useEffect, useState } from "react";
import AsyncButton from "component/AsyncButton";

import styled from "styled-components";

const WrapperForm = styled(Form)`
   .ant-form-item-label {
      min-width: 200px;
      text-align: left;
   }
`;

const CustomStyle = styled.div`
   .ant-checkbox-wrapper {
      margin-bottom: 8px;
      white-space: nowrap;
   }
   .ant-collapse {
      width: 100%;
      margin-bottom: 16px;
   }
   .ant-collapse-header {
      align-items: center !important;
      h2 {
         margin-bottom: 0;
      }
   }
   h3 {
      width: 100%;
   }
`;

const { Panel } = Collapse;

const { Option } = Select;

function Availability(props) {
   const { product, currentTab } = props;
   const productManagerActions = useProductManagerActions();
   const [form] = Form.useForm();
   const [data, setData] = useState([]);
   const [dataCategory, setDataCategory] = useState({
      list: [],
      selected: null,
   });
   const [isLoading, setIsLoading] = useState({
      getDataProduct: false,
      getDataStation: false,
   });
   const [isSubmitting, setIsSubmitting] = useState();
   const [checkedList, setCheckedList] = useState({});

   const getDataProduct = async () => {
      if (product?.id) {
         setIsLoading((state) => ({ ...state, getDataProduct: true }));
         try {
            const resGet = await productManagerActions.getProductDetail(
               product?.id
            );
            resGet.productId = resGet?.id;
            resGet.category_id = resGet?.category?.id;
            resGet.class_id = resGet?.class?.id;
            form.setFieldsValue(resGet);

            const cate = dataCategory?.list?.find((category) => {
               return category?.id === resGet?.category?.id;
            });
            setDataCategory((state) => ({ ...state, selected: cate }));
         } finally {
            setIsLoading((state) => ({ ...state, getDataProduct: false }));
         }
      } else {
         form.resetFields();
      }
   };

   const getDataStation = async () => {
      try {
         setIsLoading((state) => ({ ...state, getDataStation: true }));
         const resGet = await productManagerActions.getStationsAssignItem({
            item_id: product?.id,
         });
         setData(resGet);
         const defaultChecked = {};
         resGet?.forEach((item) => {
            defaultChecked[item.country] = {};
            item?.data?.forEach((region) => {
               region?.stores?.forEach((store) => {
                  const station = store?.stations?.find((x) => x.isActive);
                  defaultChecked[item.country][store?.id?.toString()] =
                     station?.id || null;
               });
            });
         });

         setCheckedList(defaultChecked);
      } finally {
         setIsLoading((state) => ({ ...state, getDataStation: false }));
      }
   };

   const onStationClick = (storeId, stationId, country) => {
      const currentStationId = checkedList[country][storeId];
      const currentChecked = { ...checkedList };
      console.log(stationId, currentStationId);
      if (stationId === currentStationId) {
         currentChecked[country][storeId] = null;
      } else {
         currentChecked[country][storeId] = stationId;
      }
      setCheckedList(currentChecked);
   };

   const handleUpdate = async (country, apiEndpoint) => {
      const stationIds = [];
      for (const storeId in checkedList[country]) {
         if (checkedList[country][storeId])
            stationIds.push(checkedList[country][storeId]);
      }
      setIsSubmitting(country);
      try {
         await productManagerActions.updateStationsAssignItem(
            product?.id,
            {
               station_ids: stationIds,
               endpoint: apiEndpoint,
            },
            apiEndpoint
         );
         message.success("Update item station success!");
      } finally {
         setIsSubmitting(null);
      }
   };

   useEffect(() => {
      if (product?.id) {
         getDataProduct();
         getDataStation();
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [product, currentTab]);

   return (
      <>
         <Spin spinning={isLoading?.getDataProduct}>
            <div className="p-8 mt-8 bg-white-0 rounded-sm shadow-sm">
               <WrapperForm name="product-form" form={form}>
                  <div className="grid grid-cols-2 gap-20">
                     <div>
                        <Form.Item name="productId" label="Product Id">
                           <Input disabled placeholder="Product Id" />
                        </Form.Item>
                        <Form.Item name="category_id" label="Category">
                           <Select disabled placeholder="Category">
                              {dataCategory?.list?.map((category) => (
                                 <Option
                                    key={category?.id}
                                    value={category?.id}
                                 >
                                    {category?.name}
                                 </Option>
                              ))}
                           </Select>
                        </Form.Item>
                     </div>
                     <div>
                        <Form.Item name="name" label="Name">
                           <Input disabled placeholder="Name" />
                        </Form.Item>
                        <Form.Item name="class_id" label="Class">
                           <Select placeholder="Class" disabled>
                              {dataCategory.selected?.classCate?.map((cl) => (
                                 <Option key={cl?.id} value={cl?.id}>
                                    {cl?.name}
                                 </Option>
                              ))}
                           </Select>
                        </Form.Item>
                     </div>
                  </div>
               </WrapperForm>
            </div>
         </Spin>
         <Spin spinning={isLoading?.getDataStation}>
            <CustomStyle className="mt-8">
               {data.map((item, index) => (
                  <>
                     <Collapse>
                        <Panel
                           header={
                              <h2 className="uppercase">{item.country}</h2>
                           }
                           key={index}
                        >
                           {item?.data?.map((region) => (
                              <Collapse>
                                 <Panel
                                    header={
                                       <h3 className="uppercase mb-0">{`${region?.country} - ${region?.cityname}`}</h3>
                                    }
                                    key={region?.id}
                                 >
                                    {region?.stores?.map((store, index) => (
                                       <div key={store?.id}>
                                          {index !== 0 && <Divider />}
                                          <h3 className="capitalize">
                                             {store?.full_name}
                                          </h3>
                                          <Radio.Group
                                             value={
                                                checkedList[item?.country]
                                                   ? checkedList[item?.country][
                                                        store?.id
                                                     ]
                                                   : ""
                                             }
                                             style={{ width: "100%" }}
                                          >
                                             <div className="flex flex-wrap">
                                                {store?.stations?.map(
                                                   (station) => (
                                                      <div
                                                         key={station?.id}
                                                         className="flex w-1/3 my-4"
                                                      >
                                                         <Radio
                                                            style={{
                                                               display: "flex",
                                                               marginBottom: 0,
                                                            }}
                                                            value={station?.id}
                                                            onClick={() =>
                                                               onStationClick(
                                                                  store?.id,
                                                                  station?.id,
                                                                  item?.country
                                                               )
                                                            }
                                                         >
                                                            <h4 className="capitalize mb-0">
                                                               {station?.name}
                                                            </h4>
                                                         </Radio>
                                                      </div>
                                                   )
                                                )}
                                             </div>
                                          </Radio.Group>
                                       </div>
                                    ))}
                                 </Panel>
                              </Collapse>
                           ))}
                           {item?.data?.length > 0 && (
                              <div className="mt-8 p-8 text-right flex justify-end shadow-sm">
                                 <AsyncButton
                                    isLoading={isSubmitting == item.country}
                                    type="primary"
                                    onClick={() =>
                                       handleUpdate(item.country, item.endpoint)
                                    }
                                    className="ml-16"
                                 >
                                    Submit
                                 </AsyncButton>
                              </div>
                           )}
                        </Panel>
                     </Collapse>
                  </>
               ))}
            </CustomStyle>
         </Spin>
      </>
   );
}

export default Availability;
